import { createStringEnum, EnumValues } from '@lib/shared-interface-utility-types';

export const SCHOOL_ACCOUNT_PLANS = ['BASIC', 'PREMIUM', 'FULL_ACCESS'] as const;

export const SchoolAccountPlan = createStringEnum(SCHOOL_ACCOUNT_PLANS);
export type SchoolAccountPlan = EnumValues<typeof SchoolAccountPlan>;

export function getDisplayedPlanName(plan: SchoolAccountPlan): string {
    switch (plan) {
        case SchoolAccountPlan.BASIC: {
            return 'Basic';
        }
        case SchoolAccountPlan.PREMIUM: {
            return 'Premium';
        }
        case SchoolAccountPlan.FULL_ACCESS: {
            return 'All Access';
        }
    }
}
